import { Divider, Flex, Space, Stack } from "@mantine/core";
import style from "./contact-us.module.css";
import { useTranslation } from "react-i18next";

import CopyEmailButton from "./copy-email";
import Navbar from "../navbar/navbar";

export const ContactUsSegment = () => {
    const { t, i18n } = useTranslation("landing-page");
    
    // Get the appropriate email domain based on current language
    const getEmailDomain = () => {
        switch (i18n.language) {
            case 'en':
                return 'gradr.ai';
            case 'sv':
                return 'verklig.ai';
            case 'da':
                return 'virkelig.ai';
            default:
                return 'ekte.ai';
        }
    };
    
    const emailDomain = getEmailDomain();

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.grid}>
                    <Stack maw={400} spacing={"0.5rem"}>
                        <h2 className={style.header}>{t("contact.title")}</h2>

                        <p className={style.text}>{t("contact.intro")}</p>

                        <Divider my={"1rem"} />

                        <p className={style.label}>{t("contact.new_inquiries")}:</p>
                        <CopyEmailButton email={`kontakt@${emailDomain}`} />

                        <Space mt={"2rem"} />

                        <p className={style.label}>{t("contact.customer_service")}:</p>
                        <CopyEmailButton email={`support@${emailDomain}`} />
                    </Stack>

                    <Stack align="baseline" h={"100%"} mt={"10rem"}>
                        <p className={style.text}>{t("contact.company_name", { brand: t("brand") })}</p>

                        <p className={style.text}>{t("contact.address.street")}</p>
                        <p className={style.text}>{t("contact.address.city")}</p>

                        <br />
                        <p className={style.text}>{t("contact.vat_number")}</p>
                    </Stack>
                </div>
            </div>
        </div>
    );
};

export const ContactUsPage = () => {
    return(
        <>
            <Navbar />
            <div className={style.page}>
                <ContactUsSegment />
            </div>
        </>
    )
}
